import { ListModel } from '../models/list/list.model';
import { ListStylingModel } from '../models/list/list-styling.model';

export const /** @type {?} */ ListTemplates = {
  defaultTemplate: {
    property: new ListModel({
      display: true,
      disable: false,
      title: 'My List'
    }),
    style : new ListStylingModel({
      container: {
        class: '',
        dynamicClass: ''
      },
      title: {
        class: '',
        dynamicClass: ''
      }
    })
  }
}
